import styled from '@emotion/styled'
import { unifiedColors } from 'styles/colors'
import { themeUtils } from 'styles/theme'

export const StyledCountryOptionContent = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ${themeUtils.bodySmall}
  overflow-wrap: anywhere;
`

export const StyledCountryTrigram = styled.div`
  display: flex;
  justify-content: center;
  padding: 3px 5px;
  border-radius: 4px;
  margin-right: 10px;
  align-items: center;
  background-color: ${unifiedColors.shadow.tertiary};
`

export const StyledNameContainer = styled.div`
  height: fit-content;
  overflow-wrap: break-word;
  word-wrap: break-word;
`
